import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { API_RESPONSE_MESSAGES } from 'app/static/api';
import { HttpMethodsEnum } from 'app/static/enums';
import { HttpError } from 'app/static/http-error';

// Rxjs
import { Observable, throwError } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { appConfig } from 'app/static/application-config';


@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(
    private readonly httpClient: HttpClient
  ) {}

  /**
   * gereric Http Request method
   * @param method [HttpMethodsEnum] one of 'POST', 'GET', 'DELETE', 'PUT'
   * @param url [string]
   * @param options [any] HttpClient Options (headers, body, observe, reportProgress, ...)
   * @returns [Observable<any>]
   */
  request(method: HttpMethodsEnum, url: string, options?: any): Observable<any> {
    // prepend api base url to the api end point
    const fullurl = this.prepareUrl(url);

    return this.httpClient.request(method, fullurl, options)
      .pipe(
        timeout(appConfig.HTTP_TIMEOUT),
        catchError(this.handleError)
      )
  }




  /*****************************************************************************
   * ***************************************************************************
   * ***************************************************************************
   * ***************************************************************************
   * ********************* Private Methods Section *****************************
   * ***************************************************************************
   * ***************************************************************************
   * ***************************************************************************
   *****************************************************************************/

  /**
   * if request url is already a full url(starts with http:// or https://)
   * DO NOT prepend baseUrl to it, otherwise do
   * @param url [string]
   */
  private prepareUrl(url: string): string {
    return url.startsWith('http') ? url : (environment.baseUrl + url);
  }

  /**
  * http Error Handler
  * @param error [HttpErrorResponse]
  */
  private handleError(error: HttpErrorResponse): Observable<never> {
    console.error(
      `There was as Error with code: ${error.status}`,
      `The error Object is type of: ${error.error}`
    );

    const err: HttpError = {
      message: API_RESPONSE_MESSAGES.SERVER_CONNECTION_ERROR,
      error: error,
      ok: false
    }

    // return an observable with a user-facing error message
    return throwError(err);
  };

}
